import { createContext, useContext } from 'react'
import { brandingToCssVars, resolveBranding } from '@feed-widget/branding'
import { getFallbackTemplate, normalizeTemplates } from '../../../../../shared/pkg/prepacks/templateVariants.js'

const defaultBranding = resolveBranding({})
export const PrepackPreviewContext = createContext({
  branding: defaultBranding,
  cssVars: brandingToCssVars(defaultBranding),
  surface: null,
  oddsFormat: 'american',
  fallbackTemplate: getFallbackTemplate(normalizeTemplates()),
})
export function usePrepackPreview() {
  return useContext(PrepackPreviewContext)
}
